/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./forturn.vue?vue&type=template&id=1fa05042&scoped=true"
import script from "./forturn.vue?vue&type=script&lang=js"
export * from "./forturn.vue?vue&type=script&lang=js"
import style0 from "./forturn.vue?vue&type=style&index=0&id=1fa05042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa05042",
  null
  
)

export default component.exports